import React, { FC } from 'react'

import { SearchNarrowDown } from 'src/components/molecules/inputs/SearchNarrowDown'

type Props = {
  isSearchEnabled: boolean
  className?: string
}

export const ProjectSearchNarrowDown: FC<Props> = ({ isSearchEnabled, className }) => {
  return <SearchNarrowDown isSearchEnabled={isSearchEnabled} className={className} />
}
